import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { getPathName, ScrollToTop, setDefaultAll } from '../CodeEasier'
import { static_img_url } from '../Variables'
import LazyImage from './LazyImage'

function NotAuthorized({message = 'Oops! You can not access this page, Please login to continue.'}) {
  const navigate = useNavigate()
  const location = useLocation()
  const [path, setPath] = useState('/')
  const dispatch = useDispatch()

  useEffect(()=>{
     setPath(getPathName(location))
     setDefaultAll(dispatch, true)
  },[location])

  return (
    <div className='handlers'>

      <ScrollToTop/>
      <LazyImage src={`${static_img_url}/handlers/notauth.webp`} alt='Image' />
      <div className='mt-3 mb-3'>{message}</div>
      <button className='h6 primaryButton' onClick={() => navigate(`/user/loginUser/?redirect=${path}`)}>Login</button>
    </div>
  )
}

export default NotAuthorized